<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img
            src="@/assets/admin-icon/home-active.svg"
          /><pathViewer></pathViewer>
        </div>
        <div class="ribbon-options">
          <button class="btn-customer-user">
            <img
              class="profile-logo"
              v-if="$getLoggedUser().manager_picture"
              :src="
                $fullUrl('images/profiles/' + $getLoggedUser().manager_picture)
              "
            />
            <img v-else class="profile-logo" src="@/assets/avatar.png" />
            <span>{{ $getLoggedUser().manager_name | validate }}</span>
            <img src="@/assets/admin-icon/allow-down.svg" />
          </button>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="consultant-profile-wrapper">
        <div class="__head">
          <!-- Tab section -->
          <div class="tabs-widget">
            <div class="profile-widget">
              <img src="@/assets/icons/microsoft_logo.png" />
              <h3>Sagamba Denis</h3>
              <p>Senior Consultant, partner</p>
            </div>
            <div class="tabs-links">
              <div
                class="tab"
                :class="{ active: tab_type == 'public-information' }"
                @click="switchTab('public-information')"
              >
                <span class="name">Public information</span>
                <span class="icon">
                  <img
                    v-if="tab_type == 'public-information'"
                    src="@/assets/icons/consultant-profile-icons/general-infos-active.svg"
                  />
                  <img
                    v-else
                    src="@/assets/icons/consultant-profile-icons/general-infos.svg"
                  />
                </span>
              </div>
              <div
                class="tab"
                :class="{ active: tab_type == 'project' }"
                @click="switchTab('project')"
              >
                <span class="name">Projects</span>
                <span class="icon">
                  <img
                    v-if="tab_type == 'project'"
                    src="@/assets/icons/consultant-profile-icons/projects-active.svg"
                  />
                  <img
                    v-else
                    src="@/assets/icons/consultant-profile-icons/projects.svg"
                  />
                </span>
              </div>
              <div
                class="tab"
                :class="{ active: tab_type == 'skills' }"
                @click="switchTab('skills')"
              >
                <span class="name">Skills</span>
                <span class="icon">
                  <img
                    v-if="tab_type == 'skills'"
                    src="@/assets/icons/consultant-profile-icons/skills-active.svg"
                  />
                  <img
                    v-else
                    src="@/assets/icons/consultant-profile-icons/skills.svg"
                  />
                </span>
              </div>
              <div
                class="tab"
                :class="{ active: tab_type == 'employment' }"
                @click="switchTab('employment')"
              >
                <span class="name">Employment</span>
                <span class="icon">
                  <img
                    v-if="tab_type == 'employment'"
                    src="@/assets/icons/consultant-profile-icons/employment-active.svg"
                  />
                  <img
                    v-else
                    src="@/assets/icons/consultant-profile-icons/employment.svg"
                  />
                </span>
              </div>
              <div
                class="tab"
                :class="{ active: tab_type == 'qualification' }"
                @click="switchTab('qualification')"
              >
                <span class="name">Qualification</span>
                <span class="icon">
                  <img
                    v-if="tab_type == 'qualification'"
                    src="@/assets/icons/consultant-profile-icons/qualification-active.svg"
                  />
                  <img
                    v-else
                    src="@/assets/icons/consultant-profile-icons/qualification.svg"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="__body">
          <div class="consultant-profile-container">
            <!-- Tab body section -->
            <div class="tab-body">
              <PublicInformation
                v-if="tab_type == 'public-information'"
              ></PublicInformation>
              <Project v-if="tab_type == 'project'"></Project>
              <Skills v-if="tab_type == 'skills'"></Skills>
              <Employment v-if="tab_type == 'employment'"></Employment>
              <Qualification v-if="tab_type == 'qualification'"></Qualification>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import Employment from "@/components/Consultant/Employment.vue";
import Project from "@/components/Consultant/Project.vue";
import PublicInformation from "@/components/Consultant/PublicInformation.vue";
import Qualification from "@/components/Consultant/Qualification.vue";
import Skills from "@/components/Consultant/Skills.vue";

import { mapGetters } from "vuex";
export default {
  name: "consultants",
  components: {
    Employment,
    Project,
    PublicInformation,
    Qualification,
    Skills,
    dropdownMenu,
  },
  props: {},
  data: () => {
    return {
      tab_type: "public-information",
      isScoll: false,
      profile_data: {
        projects: [],
        skills: [],
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.tab_type = val;
    },
  },
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Profile",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.getProfileData();
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    } else {
      vm.tab_type = "public-information";
    }
  },
  computed: {},
  methods: {
    onScoll({ target }) {
      let vm = this;
      vm.isScoll = true;
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_ME_PROFILE_DATA").then((response) => {
        let data = response.data;
        vm.profile_data = data;
      });
    },
    switchTab(type) {
      let vm = this;
      vm.$router.push({ path: "/profile/" + type });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      padding: 10px 15px;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d0d0d0;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }
  .page-body {
    overflow-y: auto;
    height: calc(100% - 40px);
    background: #fff;
    .consultant-profile-wrapper {
      display: grid;
      grid-template-columns: 300px calc(90% - 300px);
      align-items: flex-start;
      grid-column-gap: 80px;
      background: #efefef;
      .__head {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 300px;
        padding: 15px 15px;
        .tabs-widget {
          display: flex;
          flex-direction: column;
          width: 100%;
          background: #fff;
          border-radius: 5px;
          height: 90vh;
          .profile-widget {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 20px;
            img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              color: #0884af;
            }
            h3 {
              margin: 0px;
              font-size: 16px;
            }
            p {
              color: #707070;
              margin: 0px;
            }
          }
          .tabs-links {
            width: 100%;
            display: flex;
            flex-direction: column;

            .tab {
              cursor: pointer;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              padding: 0px 15px;
              .name {
                display: block;
                @media (min-width: 300px) and (max-width: 630px) {
                  display: none;
                }
              }
              .icon {
                display: none;
                background: #dedede;
                height: 40px;
                width: 40px;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                @media (min-width: 300px) and (max-width: 630px) {
                  display: flex;
                }
                img {
                  width: 22.9px;
                }
              }
            }
            .tab.active {
              color: #fff;
              background: #0884af;
              font-weight: 800;
              .icon {
                background: #1890a9;
              }
            }
            .tab:hover {
              color: #fff;
              background: #0884af;
            }
          }
        }
      }

      .__body {
        width: 100%;
        .consultant-profile-container {
          width: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          .tab-body {
            width: 800px;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>